module.exports = __webpack_public_path__ + "static/gate1-logo-ba335f61f3d84a369424d66a642e04bd.png";